import styled, { css } from 'styled-components'

export const Container = styled.section`
  ${props => props.withMargin && css`
    margin: 35px 0;
  `}
  
  ${props => props.rounded && css`
     @media (min-width: 1001px) {
       overflow: hidden;
       border-radius: 20px;
     }
  `}
`

export const VkWrapper = styled.div`
  width: 100% !important;
  
  iframe {
    width: 100% !important;
  }
`

export const IframeWrapper = styled.div`
  position: relative;
  
  ${props => props.youTube && css`
     padding-bottom: 56.25%;
     height: 0;
     
     iframe {
       position: absolute;
       top: 0;
       left: 0;
       width: 100% !important;
       height: 100% !important;
     }
  `}

  iframe {
    width: 100% !important;
  }
  
  iframe[src*="music.yandex.ru"] {
    width: 100% !important;
    height: 500px !important;
    
  }
`
